// theme.js — "Atlas Standard" MUI 7 light theme (US-874 · R-2).
//
// Built from the design tokens in ./theme/tokens.js (the single source of
// truth). Replaces the legacy dark theme; applied app-wide in App.js via
// ThemeProvider + CssBaseline. Feature US must not define their own palette or
// typography — they consume this theme.
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import {
  colors,
  layerColors,
  fonts,
  spacing,
  layout,
  shadows,
  rainbow,
} from "./theme/tokens";

let theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.navy,
      dark: colors.navyDeep,
      light: colors.navyTint,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.gold,
      contrastText: colors.textDarkest,
    },
    background: {
      default: colors.canvas,
      paper: colors.white,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.annotation,
    },
    divider: colors.borderLight,
  },
  // The mockup uses square, institutional corners throughout (border-radius: 0).
  shape: {
    borderRadius: 0,
  },
  typography: {
    fontFamily: fonts.sans,
    // Display headings use the serif face (mockup: titles/figures in serif).
    h1: { fontFamily: fonts.serif },
    h2: { fontFamily: fonts.serif },
    h3: { fontFamily: fonts.serif },
    h4: { fontFamily: fonts.serif },
    h5: { fontFamily: fonts.serif },
    h6: { fontFamily: fonts.serif },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.canvas,
          color: colors.textPrimary,
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: "none" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        // Avoid MUI's dark-mode overlay; surfaces are flat white on canvas.
        root: { backgroundImage: "none" },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

// Expose the non-MUI tokens (layout dimensions, brand shadows, fonts, layer and
// rainbow palettes) on the theme so components read one source in `sx`, e.g.
// theme.tokens.layout.headerH or theme.tokens.shadows.card.
theme.tokens = { colors, layerColors, fonts, spacing, layout, shadows, rainbow };

export default theme;
